// src/pages/HsCodePage.jsx
import React, { useEffect, useRef } from "react";
import Header from "../components/Header";

/**
 * HS Code Lookup embed (adamftd.org) — React-safe version
 *
 * Why these patterns:
 * - Initialize after mount so the container exists.
 * - Dynamically load the external script if missing.
 * - Guard against double init in React 18 Strict Mode.
 */
const SCRIPT_SRC = "https://adamftd.org/cdn/embed.js";
const SCRIPT_ATTR = "data-adamftd-embed"; // marker to avoid duplicate <script>
const CONTAINER_ID = "adamftd-embedded-container"; // must match config.containerId

export default function HsCodePage() {
  const containerRef = useRef(null);
  const initedRef = useRef(false); // prevents double load in Strict Mode

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const initEmbed = () => {
      if (initedRef.current) return; // Strict Mode guard
      if (
        !window.adamftd_embedded ||
        typeof window.adamftd_embedded.load !== "function"
      ) {
        console.error("adamftd embed API not available after script load");
        return;
      }
      initedRef.current = true;
      window.adamftd_embedded.load({
        apiKey: "1uygX8zrZFBl8XYTJGmABRNKszdYNVzRMgWgXQKGxIg",
        affiliateCode: "prolognet978",
        containerId: CONTAINER_ID,
        url: "https://adamftd.org/public/ai_hs_code_labeling",
      });
    };

    const ensureScript = () =>
      new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[${SCRIPT_ATTR}]`);
        if (existing) {
          if (window.adamftd_embedded) resolve();
          else existing.addEventListener("load", resolve, { once: true });
          existing.addEventListener("error", reject, { once: true });
          return;
        }
        const s = document.createElement("script");
        s.src = SCRIPT_SRC;
        s.defer = true;
        s.async = true;
        s.setAttribute(SCRIPT_ATTR, "true");
        s.addEventListener("load", resolve, { once: true });
        s.addEventListener(
          "error",
          () => reject(new Error("Failed to load adamftd embed script")),
          { once: true }
        );
        document.head.appendChild(s);
      });

    let cancelled = false;
    ensureScript()
      .then(() => {
        if (!cancelled) initEmbed();
      })
      .catch((err) => {
        console.error(err);
        if (container)
          container.textContent =
            "Failed to load HS Code Lookup. Please retry.";
      });

    return () => {
      cancelled = true;
      // Clear container to avoid duplicate UI if the component remounts
      if (container) container.innerHTML = "";
    };
  }, []);

  return (
    <>
      <div>
        <Header />
      </div>

      <div
        style={{
          marginTop: "120px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></div>
      <div
        id={CONTAINER_ID}
        ref={containerRef}
        style={{
          width: "90vw",
          height: "90vh",
          margin: "auto",
        }}
        aria-label="HS Code Lookup"
      />
    </>
  );
}
